import { GetfilialFaturamento, GetlogSugestaoPedidos, PedidoModel, Produto , GetCondicaoPagamento, PayloadUpdateUnidadeCaixa, ResponseUpdateUnidadeCaixa, ResponseEnvioPhoteus, SugestaoPedidoItens } from "@/models/SugestaoPedidoModel";

import ApiService from "./ApiService";

type ListaPedidos = PedidoModel [];

export const getListaPedidos = async (codConcessionaria: any): Promise<ListaPedidos> => {
    const { data } = await ApiService.get(`/getSugestaoPedidos/${codConcessionaria}`);
    return data;
};

export const salvarSugestaoPedido = async (informacoesItensTodosProdutos) => {
    const { data } = await ApiService.post(`/salvarSugestaoPedidos`, informacoesItensTodosProdutos);
    return data
};

export const getSugestaoPedidosEstoqueItens = async (codConcessionaria: any, codSugestaoPedido: number): Promise<Produto[]> => {
    const { data } =  await ApiService.get(`/getSugestaoPedidosEstoqueItens/${codConcessionaria}/${codSugestaoPedido}`);
    return data
};

export const getlogSugestaoPedidos = async (codSugestaoPedido) : Promise<GetlogSugestaoPedidos[]>=> {
    const { data } =  await ApiService.get(`/getlogSugestaoPedidos/${codSugestaoPedido}`);
    return data
};

export const getSugestaoPedidosItensParaEnviar = async (codConcessionaria: any, codSugestaoPedido: number, hashPedido: string): Promise<SugestaoPedidoItens[]> => {
    const { data } =  await ApiService.get(`/getSugestaoPedidosItensParaEnviar/${codConcessionaria}/${codSugestaoPedido}/${hashPedido}`);
    return data
};

export const enviarPedidoAoErp = async (ArrayDataPedidos) : Promise<ResponseEnvioPhoteus> => {
    const { data } = await ApiService.post(`/enviarPedidoAoErp`, ArrayDataPedidos);
    return data
};

export const logEnvioPedidoErp = async (postData) => {
    const { data } = await ApiService.post(`/logEnvioPedidoErp`, postData);
    return data
};

export const getFilialFaturamentoCadastrada = async (codConcessionaria: number) : Promise<GetfilialFaturamento> => {
    const { data } = await ApiService.get(`/getFilialFaturamentoCadastrada/${codConcessionaria}`);
    return data;
}

export const getStatusPedido = async (codConcessionaria: number, postData) => {
    const { data } = await ApiService.post(`/getStatusPedido/${codConcessionaria}`, postData);
    return data;
}

export const getCondicaoPagamento = async () : Promise<GetCondicaoPagamento[]> => {
    const { data } = await ApiService.get(`/condicaoPagamento`);
    return data;
}

export const updateUnidadeCaixa = async (payload : PayloadUpdateUnidadeCaixa) : Promise<ResponseUpdateUnidadeCaixa>  => {
    const { data } = await ApiService.post(`update/unidadeCaixa/`, payload as Object);
    return data;
}

